import React from 'react';
import layout_1 from './layout_1.svg';
import layout_2 from './layout_2.svg';
import layout_3 from './layout_3.svg';
import layout_4 from './layout_4.svg';
import ic_active from './ic_active.svg';
import { get } from 'lodash';
import styled from 'styled-components';
import Text from 'components/Text';
import { HomeLayoutCode } from 'services/shop/constants';

const configs = {
  [HomeLayoutCode.LAYOUT_1]: {
    icon: layout_1,
    name: 'LAYOUT 1',
  },
  [HomeLayoutCode.LAYOUT_2]: {
    icon: layout_2,
    name: 'LAYOUT 2',
  },
  [HomeLayoutCode.LAYOUT_3]: {
    icon: layout_3,
    name: 'LAYOUT 3',
  },
  [HomeLayoutCode.LAYOUT_4]: {
    icon: layout_4,
    name: 'LAYOUT 4',
  },
};
type Props = {
  active?: boolean;
  onClick?: () => void;
  code: HomeLayoutCode;
}
const LayoutButton = ({ code, active, onClick }: Props) => {
  const config = get(configs, code, null);
  if (!config) return null;
  return (
    <Button type='button' onClick={onClick}>
      <Text variant='H9'>{config.name}</Text>
      <img className='layout_image' src={config.icon} alt={config.name} />
      {active && <img className='active-icon' src={ic_active} alt='active' />}
    </Button>
  );
};

export default LayoutButton;

const Button = styled.button`
  position: relative;
  display: flex;
  padding: 24px 32px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.40), 0 4px 8px -3px rgba(45, 35, 66, 0.30), 0 -3px 0 0 #D6D6E7 inset;

  .layout_image {
    width: 10vw;
    height: auto;
  }
  .active-icon {
    position: absolute;
    right: 12.333px;
    top: 12px;
    width: 40px;
    height: 40px;
  }

  &:active, &:hover {
    background: #F5F5F5;
  }

  .H9 {
    font-size: 24px;
  }
`;